import { runInAction } from 'mobx';
import { VerificationData } from '@monorepo/types';
import { useStore } from '@hub/helpers/use-store';
import { KYC_TOKEN_KEY } from '@hub/stores/data/user/user-store';
import {
  QUERY_CONFIGS,
  QueryConfigKeys,
} from '@hub/utils/react-query/query-config';
import {
  fetchKycAccessToken,
  fetchUserVerificationData,
} from '@hub/utils/react-query/query-functions';
import { QUERY_KEYS } from '@hub/utils/react-query/query-keys';
import { ExtractFnReturnType } from '@hub/utils/react-query/react-query';
import { useQuery } from '@tanstack/react-query';

const CONFIG_KEY = QueryConfigKeys.KYC;

export const useKycAccessToken = () => {
  return useQuery<ExtractFnReturnType<typeof fetchKycAccessToken>>({
    queryKey: QUERY_KEYS[CONFIG_KEY].ACCESS_TOKEN,
    queryFn: fetchKycAccessToken,
    staleTime: QUERY_CONFIGS[CONFIG_KEY].staleTime,
    meta: {
      onSuccess: (kycToken: string) => {
        runInAction(() => {
          localStorage.setItem(KYC_TOKEN_KEY, kycToken);
        });
      },
    },
  });
};

export const useUserVerificationData = () => {
  const {
    dataStore: { userStore },
  } = useStore();

  return useQuery<ExtractFnReturnType<typeof fetchUserVerificationData>>({
    queryKey: QUERY_KEYS[CONFIG_KEY].VERIFICATION_DATA,
    queryFn: fetchUserVerificationData,
    staleTime: QUERY_CONFIGS[CONFIG_KEY].staleTime,
    meta: {
      onSuccess: (userVerificationData: VerificationData) => {
        runInAction(() => {
          userStore.setCurrentUser({
            ...userStore.currentUser,
            verificationData: userVerificationData,
          });
        });
      },
    },
  });
};
